//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Icon } from "@iconify/vue2";
export default {
    name: "SectionProximamenteIa",
    components: { Icon },
    props: {
        slug: String,
        name: String,
    }
};
